import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  PlanRemarksTable,
  PlanServicesMinutesTable,
  PlanServicesReachabilityTable,
  PlanServicesTable,
  PlanDialFormatTable,
} from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { planDetailsApi } from '@reducers/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const ServicesTab = () => {
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const { data, isLoading, isFetching, isError } =
    planDetailsApi.useGetReachabilityQuery(queryArg);
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <>
      <Row>
        <Col md={4}>
          <PlanServicesReachabilityTable data={[data.reachability]} />
        </Col>
        <Col md={4}>
          <PlanServicesTable data={[data.services]} />
        </Col>
        <Col md={4}>
          <PlanServicesMinutesTable data={[data.minutes]} />
        </Col>
      </Row>
      <Row>
        <Col md={4} style={{ marginTop: '7px', marginBottom: '7px' }}>
          <PlanDialFormatTable data={[data]} />
        </Col>
      </Row>
      <Row>
        <PlanRemarksTable data={[data]} />
      </Row>
    </>
  );
};
